module.exports = require('./helpers/bundle-url').getBundleURL('37CdW') + "BankID.04adb032.svg";